/* global Promise, Uint8Array, window */
import angular from 'angular';
import supportDataService from '../data/support.data.service';
import ISharedModelService from './ISharedModel.service';


let _supportDataService;

class supportSharedModelService extends ISharedModelService {
  constructor(
    supportDataService // eslint-disable-line no-shadow
  ) {
    super('support');
    _supportDataService = supportDataService;
    console.log('app.services.supportSharedModelService created');
  }

  /**
   * @typedef {Object} displayLists
   */

  /**
   *
   * @public
   * @async
   * @returns {Promise<displayLists>} An object containing list collections
   */
  getDisplayLists() {
    return _supportDataService.getDisplayLists().then(response => response.data);
  }

  transferQualifiedAlert(qualifiedAlertId) {
    return _supportDataService.transferQualifiedAlert(qualifiedAlertId).then((response) => {
      if (response.statusText !== 'OK') {
        return Promise.reject(new Error('Error occurred while transferring Qualified alert.'));
      }
      return response.data;
    });
  }

  getTicket(ticketId) {
    return _supportDataService.getTicket(ticketId).then(response => response.data);
  }

  printTicket(ticketId) {
    return _supportDataService.printTicket(ticketId).then(response => response.data);
  }

  /**
   * @typedef {Object} searchParams
   * @property type
   * @property ticketNumber
   * @property keyword
   * @property fromDate
   * @property toDate
   * @property contact
   * @property status
   * @property priority
   * @property sortColumn
   * @property sortAscending
   */

  /**
   *
   * @param {searchParams}
   * @return {*}
   */
  searchTickets(
    {
      type,
      ticketNumber,
      keyword,
      fromDate,
      toDate,
      contact,
      status,
      priority,
      sourceAccountManager,
      sourceCall,
      sourceClientPortal,
      sourceEmail,
      sourceFirewall,
      sourceInsourced,
      sourceLookout,
      sourceNetComply,
      sourceAdvancedEndPointSecurity,
      sourceCloudInsight,
      sortColumn,
      sortAscending
    }
  ) {
    return _supportDataService.searchTickets(
      type, ticketNumber, keyword, fromDate, toDate, contact, status, priority, sourceAccountManager, sourceCall,
      sourceClientPortal, sourceEmail, sourceFirewall, sourceInsourced, sourceLookout, sourceNetComply,
      sourceAdvancedEndPointSecurity, sourceCloudInsight, sortColumn, sortAscending
    ).then(response => response.data.result);
  }

  saveTicket(ticket) {
    return _supportDataService.saveTicket(ticket).then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
      return Promise.reject(new Error('Error occurred while saving Ticket.'));
    });
  }

  saveNote(note) {
    return _supportDataService.saveNote(note).then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
      return Promise.reject(new Error('Error occurred while saving the Note.'));
    });
  }

  getContact(contactId) {
    return _supportDataService.getContact(contactId).then((response) => {
      if (response.status === 200) {
        return response.data;
      }
      return Promise.reject(new Error('Error occurred while loading contact.'));
    });
  }

  createTicketAttachment(file, id) {
    return _supportDataService.createTicketAttachment(file, id).then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
      return Promise.reject(new Error('Error occurred while saving attachment.'));
    });
  }

  getTicketAttachment(attachmentId) {
    return _supportDataService.getTicketAttachment(attachmentId).then(response => response.data);
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) { // eslint-disable-line no-plusplus
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }
}

supportSharedModelService.$inject = [
  'supportDataService'
];

export default angular.module('app.services.supportSharedModelService', [
  supportDataService
])
  .service('supportSharedModelService', supportSharedModelService)
  .name;
